import { useState, useEffect, useMemo } from 'react';
import { CHANGELOG, CHANGELOG_VERSION, CHANGELOG_RETENTION_DAYS, ChangelogEntry } from '@/config/changelog';

const STORAGE_KEY = 'piktable_changelog_seen';

export function useChangelog() {
  const [hasUnread, setHasUnread] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const seenVersion = localStorage.getItem(STORAGE_KEY);
    setHasUnread(seenVersion !== CHANGELOG_VERSION);
  }, []);

  const markAsRead = () => {
    localStorage.setItem(STORAGE_KEY, CHANGELOG_VERSION);
    setHasUnread(false);
  };

  // Filtrer les entrées des X derniers jours
  const recentEntries = useMemo(() => {
    const cutoffDate = new Date();
    cutoffDate.setDate(cutoffDate.getDate() - CHANGELOG_RETENTION_DAYS);
    
    return CHANGELOG.filter(entry => 
      new Date(entry.date) >= cutoffDate
    );
  }, []);

  return {
    hasUnread,
    isOpen,
    setIsOpen,
    markAsRead,
    entries: recentEntries,
    allEntries: CHANGELOG,
    recentCount: recentEntries.length,
  };
}
